import { useQuery } from "@tanstack/react-query";
import { useParams, useSearchParams } from "react-router-dom";
import {
  CQ_SEARCH_PARAM,
  CQParams,
} from "@src/pages/controle-quinquennal/controleQuinquennal.helper";
import { ControleQuinquennalApi } from "../controle-quinquennal.api";
import { controleQuinquennalKeys } from "./controle-quinquennal.keys";

export const useIdCQCourant = () => {
  const { idCQ } = useParams<Partial<CQParams>>();
  const [searchParams] = useSearchParams();
  return idCQ ?? searchParams.get(CQ_SEARCH_PARAM) ?? undefined;
};

export const useCQWithAxesQuery = (
  idEntreprise: string,
  options?: { refetchOnWindowFocus?: boolean | "always" }
) => {
  const idCQ = useIdCQCourant();
  return useQuery({
    queryKey: [...controleQuinquennalKeys.detail(idEntreprise), idCQ ?? null],
    queryFn: () => ControleQuinquennalApi.getCQWithAxes(idEntreprise, idCQ),
    staleTime: Infinity,
    enabled: Boolean(idEntreprise),
    ...options,
  });
};
